import type { ReactElement, ReactNode } from "react";
import { Text } from "../ui-kit";
import styles from "./PageHeader.module.css";

export interface PageHeaderProps {
  /** The view's name. Rendered as the page's single `<h1>`. */
  title: string;
  /** One sentence saying what this view shows — and, where it matters, what it deliberately does not. */
  description?: ReactNode;
  /** Right-aligned supporting content (a record count, a refresh control). */
  aside?: ReactNode;
}

/**
 * The masthead every view opens with. It owns the page's single `<h1>`, so the
 * heading outline is always view-title first — the shell contributes no
 * competing heading.
 */
export function PageHeader({ title, description, aside }: PageHeaderProps): ReactElement {
  return (
    <div className={styles.pageHeader}>
      <div className={styles.headings}>
        <Text as="h1" variant="heading" balance>
          {title}
        </Text>
        {description !== undefined ? (
          <Text variant="body" tone="muted" className={styles.description}>
            {description}
          </Text>
        ) : null}
      </div>
      {aside !== undefined ? <div className={styles.aside}>{aside}</div> : null}
    </div>
  );
}
